import { render, staticRenderFns } from "./SortDropdown.vue?vue&type=template&id=fa92c588&scoped=true"
import script from "./SortDropdown.vue?vue&type=script&lang=js"
export * from "./SortDropdown.vue?vue&type=script&lang=js"
import style0 from "./SortDropdown.vue?vue&type=style&index=0&id=fa92c588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa92c588",
  null
  
)

export default component.exports